export const IS_DEVELOPMENT = process.env.NODE_ENV === "development";
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID ?? "";
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET ?? "";
export const SIX_PILLARS_API_KEY =
  process.env.REACT_APP_SIX_PILLARS_API_KEY ?? "";
export const TOKEN_EXCHANGE_ENCRYPTION_KEY =
  process.env.REACT_APP_TOKEN_EXCHANGE_ENCRYPTION_KEY ?? "";
